import './App.css';
import About from './Components/About/JavaScript/About';
import Contact from './Components/Contact/JavaScript/Contact';
import Customers from './Components/Customers/JavaScript/Customers';
import Gallery from './Components/Gallery/JavaScript/Gallery';
import Home from './Components/Home/JavaScript/Home';
import Projects from './Components/Projects/JavaScript/Projects';
import Services from './Components/Services/JavaScript/Services';

function App() {
  return (
    <div className="app">
      <Home />
      <Services />
      <About />
      <Projects />
      <Customers />
      <Gallery />
      <Contact />
    </div>
  );
}

export default App;